import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";

import { makeStyles } from "@material-ui/core";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { bookingApi } from "functions/apis";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { MailOutline } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput";

const useStyles = makeStyles(styles);

export default function RemoveOnlineBookingHomeContentBanner(props) {
  const abortSignal = useRef(new AbortController());

  const { id } = useParams();

  const [redirect, setRedirect] = useState(false);
  const [bannerData, setBannerData] = useState({
    title: "",
    description: "",
    banner: "",
    url: "",
    bannerFileID: null
  });
  const [disabled, setDisabled] = React.useState(false);

  useEffect(() => {
    return () => abortSignal.current.abort();
  }, []);

  useEffect(() => {
    if (id) {
      bookingApi
        .get("OnlineBookingHomeContents/" + id, {
          signal: abortSignal.current.signal
        })
        .then(data => {
          setBannerData(prev => ({
            ...prev,
            title: data.title,
            banner: data.banner,
            description: data.description,
            url: data.action,
            bannerFileID: data.bannerFileID
          }));
        })
        .catch(error => console.log(error));
    }
  }, [id]);

  const classes = useStyles();

  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    bookingApi
      .delete("OnlineBookingHomeContents/Banner/" + id, {
        signal: abortSignal.current.signal
      })
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/OnlineBookingHomeContentList"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>REMOVE BANNER IMAGE</h4>
          </CardHeader>
          <CardBody>
            <p>
              <i>*Remove banner image</i>
            </p>
            <form onSubmit={handleSubmit}>
              <Button onClick={() => props.history.goBack()} value="Back">
                BACK
              </Button>
              <Button
                disabled={disabled}
                color="rose"
                type="submit"
                value="Remove"
              >
                Remove
              </Button>
            </form>
            <CustomInput
              labelText="Title"
              formControlProps={{
                fullWidth: true
              }}
              disabled
              inputProps={{
                value: bannerData.title === null ? "" : bannerData.title,
                disabled: true
              }}
            />
            <CustomInput
              labelText="Description"
              formControlProps={{
                fullWidth: true
              }}
              disabled
              inputProps={{
                value: bannerData.title === null ? "" : bannerData.description,
                disabled: true
              }}
            />
            <CustomInput
              labelText="Web Url"
              formControlProps={{
                fullWidth: true
              }}
              disabled
              inputProps={{
                value: bannerData.url === null ? "" : bannerData.url,
                disabled: true
              }}
            />
            <CustomInput
              labelText="Banner URL"
              formControlProps={{
                fullWidth: true
              }}
              disabled
              inputProps={{
                value: bannerData.banner === null ? "" : bannerData.banner,
                disabled: true
              }}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}

RemoveOnlineBookingHomeContentBanner.propTypes = {
  history: PropTypes.object
};
